<template>
  <span>
    {{ deviceISO }} {{ deviceBank }} {{ deviceModel }} {{ deviceCountry }}
  </span>
</template>

<script>
export default {
  name: 'DeviceType',
  props: ['deviceType'],
  data () {
    return {
      deviceISO: '',
      deviceMfg: 'Castles',
      deviceBank: 'Demo',
      deviceModel: '',
      deviceCountry: ''
    }
  },
  computed: {
    deviceInput: function () {
      return this.deviceType
    }
  },
  mounted () {
    if (this.deviceInput !== undefined) {
      if (this.deviceInput !== '') {
        if (this.deviceInput.indexOf('barclays_') !== -1) {
          this.deviceBank = 'Barclays'
        }
        if (this.deviceInput.indexOf('aibms_') !== -1) {
          this.deviceBank = 'AIBMS'
        }
        if (this.deviceInput.indexOf('demo_') !== -1) {
          this.deviceBank = 'Demo'
        }
        if (this.deviceInput.indexOf('mp200') !== -1) {
          this.deviceModel = 'MP200'
        }
        if (this.deviceInput.indexOf('mp200l') !== -1) {
          this.deviceModel = 'MP200L'
        }
        if (this.deviceInput.indexOf('vega3000') !== -1) {
          this.deviceModel = 'V3'
        }
        if (this.deviceInput.indexOf('v3') !== -1) {
          this.deviceModel = 'V3'
        }
        if (this.deviceInput.indexOf('_pp') !== -1) {
          this.deviceISO = 'P+'
        }
        if (this.deviceInput.indexOf('_gb') !== -1) {
          this.deviceISO = 'GoodBox'
        }
        if (this.deviceInput.indexOf('_pinpad') !== -1) {
          this.deviceModel += ' PIN Pad'
        }
        if (this.deviceInput.indexOf('_portable') !== -1) {
          this.deviceModel += ' Portable'
        }
        if (this.deviceInput.indexOf('_countertop') !== -1) {
          this.deviceModel += ' Countertop'
        }
        if (this.deviceInput.indexOf('_ethernet') !== -1) {
          this.deviceModel += ' Eth'
        }
        if (this.deviceInput.indexOf('_wifi') !== -1) {
          this.deviceModel += ' Wi-Fi'
        }
        if (this.deviceInput.indexOf('_uk') !== -1) {
          this.deviceModel += ' UK'
        }
        if (this.deviceInput.indexOf('_roi') !== -1) {
          this.deviceModel += ' IE'
        }
      }
    } else {
      this.deviceBank = 'None selected'
    }
  }
}
</script>

<style scoped>

</style>
